import React, { memo, useCallback } from 'react';

import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import { filterChipStyles } from './FilterChip.styles';

const FilterChip = memo(({ value, label, isSelected, dataTestId, onSelect }) => {
  const onClick = useCallback(() => {
    onSelect(value);
  }, [value, onSelect]);

  return (
    <Button
      data-is-selected={isSelected}
      data-testid={dataTestId}
      size="small"
      sx={filterChipStyles}
      variant="outlined"
      onClick={onClick}
    >
      {label}
    </Button>
  );
});

FilterChip.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default FilterChip;
